export default __webpack_public_path__ + "static/media/profile_image.bffa3410.svg";